exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1C5L{display:block;position:relative;float:left;width:100%}", ""]);

// exports
exports.locals = {
	"root": "_1C5L",
	"root": "_1C5L"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./containers/agence/Agence.css
// module id = 218
// module chunks = 0